/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
import type {DatasetColumn} from './DatasetColumn';
import {
  DatasetColumnFromJSON,
  DatasetColumnFromJSONTyped,
  DatasetColumnToJSON
} from './DatasetColumn';
import type {DatasetRow} from './DatasetRow';
import {DatasetRowFromJSON, DatasetRowFromJSONTyped, DatasetRowToJSON} from './DatasetRow';

/**
 *
 * @export
 * @interface Dataset
 */
export interface Dataset {
  /**
   *
   * @type {Array<DatasetColumn>}
   * @memberof Dataset
   */
  columns: Array<DatasetColumn>;
  /**
   *
   * @type {Array<DatasetRow>}
   * @memberof Dataset
   */
  rows: Array<DatasetRow>;
}

/**
 * Check if a given object implements the Dataset interface.
 */
export function instanceOfDataset(value: object): value is Dataset {
  if (!('columns' in value) || value['columns'] === undefined) return false;
  if (!('rows' in value) || value['rows'] === undefined) return false;
  return true;
}

export function DatasetFromJSON(json: any): Dataset {
  return DatasetFromJSONTyped(json, false);
}

export function DatasetFromJSONTyped(json: any, ignoreDiscriminator: boolean): Dataset {
  if (json == null) {
    return json;
  }
  return {
    columns: (json['columns'] as Array<any>).map(DatasetColumnFromJSON),
    rows: (json['rows'] as Array<any>).map(DatasetRowFromJSON)
  };
}

export function DatasetToJSON(value?: Dataset | null): any {
  if (value == null) {
    return value;
  }
  return {
    columns: (value['columns'] as Array<any>).map(DatasetColumnToJSON),
    rows: (value['rows'] as Array<any>).map(DatasetRowToJSON)
  };
}
